import { useCallback } from 'react';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';
import { useTreeCourses } from '@/data/context/TreeCoursesContext';

type CourseTreeNavigateOptions = NavigateOptions & {
  treeKey?: string;
};

const useCourseTreeNavigate = () => {
  const routerNavigate = useNavigate();
  const { tree, pathObserver } = useTreeCourses();

  const navigate = useCallback(
    (to: To | number, options?: CourseTreeNavigateOptions) => {
      if (typeof to === 'number') {
        routerNavigate(to);
        return;
      }

      const { treeKey, ...navigateOptions } = options ?? {};

      if (treeKey) {
        pathObserver?.notifyAll(
          undefined,
          tree?.current.findPath(treeKey) ?? [],
        );
      }

      routerNavigate(to, navigateOptions);
    },
    [routerNavigate, tree, pathObserver],
  );

  return { navigate };
};

export default useCourseTreeNavigate;
